module.exports = __webpack_public_path__ + "media/components/resort-webcams/static/icon--archive-9be4808be0c8ba67abeb57eb90d42807.svg";